import type { PublicQuestion } from "@aletheia/shared";
import { api } from "./client";

export interface CreateSessionResponse {
  sessionId: string;
  total: number;
  underfilled: boolean;
  question: PublicQuestion;
}

export interface SessionQuestionResponse {
  sessionId: string;
  total: number;
  completed: boolean;
  question?: PublicQuestion;
}

export interface AnswerResponse {
  correct: boolean;
  correctOptionId: string;
  explanation: string;
  selectedFeedback: string | null;
  sourceFragmentId: string;
  nextIndex: number;
  total: number;
  isLastQuestion: boolean;
}

export interface TopicBreakdownEntry {
  topic: string;
  correct: number;
  total: number;
  accuracy: number;
}

export interface ScoreResult {
  score: number;
  total: number;
  percentage: number;
  mistakeQuestionIds: string[];
  topicBreakdown: TopicBreakdownEntry[];
  strongTopics: string[];
  weakTopics: string[];
}

export interface MistakeEntry {
  questionId: string;
  topic: string;
  questionText: string;
  options: { id: string; text: string }[];
  selectedOptionId: string;
  correctOptionId: string;
  explanation: string;
  sourceFragmentId: string;
}

export interface SourceResponse {
  fragment: {
    id: string;
    bookId: string;
    chapter: string;
    section?: string;
    authors?: string;
    pageStart: number;
    pageEnd: number;
    text: string;
  };
  book: {
    id: string;
    title: string;
    author: string;
    edition?: string;
  } | null;
}

export const quizApi = {
  poolSize: () => api.get<{ total: number }>("/api/pool-size"),
  createSession: (bookId?: string, targetCount?: number) =>
    api.post<CreateSessionResponse>("/api/session", { bookId, targetCount }),
  getSession: (sessionId: string) => api.get<SessionQuestionResponse>(`/api/session/${sessionId}`),
  submitAnswer: (sessionId: string, questionId: string, selectedOptionId: string) =>
    api.post<AnswerResponse>(`/api/session/${sessionId}/answer`, { questionId, selectedOptionId }),
  complete: (sessionId: string) => api.post<ScoreResult>(`/api/session/${sessionId}/complete`),
  mistakes: (sessionId: string) => api.get<{ mistakes: MistakeEntry[] }>(`/api/session/${sessionId}/mistakes`),
  source: (fragmentId: string) => api.get<SourceResponse>(`/api/source/${fragmentId}`),
};
